import React from "react";
import { Badge } from "reactstrap";

const STATUS_MAP = {
  PENDING: { color: "warning",   label: "Validando"   },
  ERROR:      { color: "danger",    label: "Error"        },
  COMPLETED:       { color: "success",   label: "Completado"   },
  CANCELLED:  { color: "secondary", label: "Cancelado"    },
};

const TaskStatusBadge = ({ status }) => {
  const cfg = STATUS_MAP[status] ?? { color: "light", label: status ?? "—" };
  return <Badge color={cfg.color}>{cfg.label}</Badge>;
};

export default TaskStatusBadge;
